import { render, staticRenderFns } from "./TranslationDraftView.vue?vue&type=template&id=87558904"
import script from "./TranslationDraftView.vue?vue&type=script&lang=js"
export * from "./TranslationDraftView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports